// clientsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const apiUrl = process.env.REACT_APP_API_URL;
// Thunk to fetch clients from the API
export const fetchClients = createAsyncThunk(
  'clients/fetchClients',
  async () => {
    const response = await fetch(`${apiUrl}/api/clients/list`);
    return response.json();
  }
);

const clientsSlice = createSlice({
  name: 'clients',
  initialState: {
    clients: [{ id: 'H188864', name: 'H188864' }],
    loading: false,
    error: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.clients = action.payload;
        state.loading = false;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export default clientsSlice.reducer;
